<div
  class="cursor-pointer select-wrapper date-time"
  id="open-modal"
  expand="block"
  (click)="presentPopover($event)"
>
  <ion-text class="floating-label" *ngIf="value && config.label">
    {{ config.label }}
  </ion-text>
  <ion-text class="pr-6 text" [ngClass]="[value && config.label ? 'mt-4' : '']">
    {{ value ? (value | date) : config.placeholder }}
  </ion-text>
  <ion-icon
    name="calendar-outline"
    class="custom-select-icon text-[24px] absolute"
  ></ion-icon>
</div>

<ion-modal
  #popover
  [isOpen]="isOpen"
  (didDismiss)="isOpen = false"
  side="top"
  cssClass="content-fit-modal"
  alignment="center"
>
  <ng-template>
    <ion-datetime
      display-format="DD MMMM YYYY"
      presentation="date"
      mode="ios"
      picker-format="DD MMMM YYYY"
      [value]="value"
      (ionChange)="handleChange($event)"
      [showDefaultButtons]="true"
    >
    </ion-datetime>
  </ng-template>
</ion-modal>
